<template>
    <div>
        <vs-row style="direction:ltr;">
            <vs-button class="mb-4 float-right" type="flat" @click="addArticle()">افزودن مقاله</vs-button>
        </vs-row>
        <div class="items-grid-view vx-row match-height" v-if="articlesList.length" appear>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in articlesList" :key="item.id">

                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <template slot="no-body">
                        <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4 cursor-pointer">
                            <img v-if="item.thumbnail" :src="srcFile(item.thumbnail)" :alt="item.title" class="grid-view-img px-4">
                            <img v-else src="./../../../../assets/images/logo/logo.png" class="grid-view-img px-4">
                        </div>
                        <div class="item-details px-4">
                            <div class="my-4">
                                <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer">{{ item.title }}</h6>
                            </div>
                        </div>

                        <div class="flex flex-wrap">

                            <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer" @click="deleteArticle(item.id)">
                                <feather-icon icon="XIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">حذف</span>
                            </div>
                            <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer" @click="editArticle(item.id)">
                                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">ویرایش</span>
                            </div>

                            <div class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"  @click="contentArticle(item.id)">
                                <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">مشاهده</span>
                            </div>
                        </div>
                    </template>
                </vx-card>

            </div>
        </div>

        <div v-else>
            <h3>مقاله ای موجود نیست...</h3>
        </div>

        <AddArticle :popupAddArticle='popupAddArticle' @updatePopupAddArticle='updatePopupAddArticle'/>

        <EditArticle :popupEditArticle='popupEditArticle' :articleId='editArticleId' @updatePopupEditArticle='updatePopupEditArticle'/>

        <DeleteArticle :popupDeleteArticle='popupDeleteArticle' :articleId='deleteArticleId' @updatePopupDeleteArticle='updatePopupDeleteArticle'/>

        <ContentArticle :popupContentArticle='popupContentArticle' :articleId='contentArticleId' @updatePopupContentArticle='updatePopupContentArticle'/>

    </div>
</template>

<script>
import AddArticle from './Add'
import EditArticle from './Edit'
import DeleteArticle from './Delete'
import ContentArticle from './Content'

export default {
    components: {
		AddArticle,
		EditArticle,
		DeleteArticle,
		ContentArticle,
    },

    data() {
		return{
			popupAddArticle: false,
			popupEditArticle: false,
			popupDeleteArticle: false,
			popupContentArticle: false,

			editArticleId: 0,
            deleteArticleId: 0,
            contentArticleId: 0,
		}
	},

    
    computed: {
		articlesList() {
      		return this.$store.state.posts.articles
    	}
    },
    
    created() {
        this.$vs.loading()
        this.$store.dispatch("getPosts","article").then(() => {
            this.$vs.loading.close();
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
    },

    methods: {
        srcFile(src) {
            return 'https://appapi.akambc.com/' + src
        },

        addArticle(){
            this.popupAddArticle = true
		},

		editArticle(id){
			this.popupEditArticle = true
			this.editArticleId = id
		},
		
		deleteArticle(id){
			this.popupDeleteArticle = true
			this.deleteArticleId = id
        },
        
        contentArticle(id){
			this.popupContentArticle = true
			this.contentArticleId = id
		},

        updatePopupAddArticle(value){
            this.popupAddArticle = value
		},

		updatePopupEditArticle(value){
            this.popupEditArticle = value
		},
		
		updatePopupDeleteArticle(value){
            this.popupDeleteArticle = value
        },

        updatePopupContentArticle(value){
            this.popupContentArticle = value
        },
    }
}
</script>

<style scoped>
.grid-view-item .grid-view-img{
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
}

.grid-view-item:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);
}

.grid-view-item .grid-view-img{
    opacity: 0.9;
}

.item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
}

.item-view-secondary-action-btn {
    min-width: 50%;
}
</style>